
Fancybox.bind('[data-fancybox]', {
  Video: {
      autoplay: true,
      loop: true,
      muted: true,
  },
});
Fancybox.bind("[data-fancybox='p-gallery']", {
  Thumbs: false,
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ["close"],
    },
  },
}); 

document.addEventListener('DOMContentLoaded', function () {
  // BコードのSwiper初期化 (サムネイル用)
  const swiperThumbnail = new Swiper('.swiper-thumbnail', {
    slidesPerView: 'auto', // 自動でスライドをすべて表示
    spaceBetween: 0,      // スライド間の余白
    allowSlideNext: false, // スライド移動を無効化
    allowSlidePrev: false, // スライド移動を無効化
    loop: false,           // ループを無効化
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  // AコードのSwiper初期化 (メイン用)
  const swiper = new Swiper('.swiper-main', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: swiperThumbnail, // サムネイルと同期
    },
    loop: false,
    pagination: {
      el: ".swiper-pagination", // ページネーションのクラス名を指定
      type: "fraction", // ページネーションのtypeを指定
    }
  });

  // Aコードのスライド要素を監視
  const swiperWrapper = document.querySelector('.swiper-wrapper-main');
  const swiperWrapperThumbnail = document.querySelector('.swiper-wrapper-thumbnail');

  if (!swiperWrapper || !swiperWrapperThumbnail) {
    console.error('Swiper-wrapperが見つかりません');
    return;
  }

  // AコードをBコードに同期する関数
  const syncSlides = () => {
    // Bコードをクリア
    swiperWrapperThumbnail.innerHTML = '';

    // Aコードのスライドを複製してBコードに追加
    swiperWrapper.childNodes.forEach((slide) => {
      if (slide.nodeType === 1 && slide.matches('.swiper-slide')) { // 要素ノードのみ
        const img = slide.querySelector('img'); // imgタグのみ抽出
        if (img) {
          // 新しいswiper-slideを作成し、imgタグを追加
          const newSlide = document.createElement('li');
          newSlide.classList.add('swiper-slide'); // 必要なクラスのみ追加
          const clonedImg = img.cloneNode(true); // imgタグのみ複製
          clonedImg.removeAttribute('class'); // imgタグのclass属性を削除
          clonedImg.removeAttribute('id'); // imgタグのid属性を削除
          newSlide.appendChild(clonedImg);
          swiperWrapperThumbnail.appendChild(newSlide);
        }
      }
    });

    // BコードのSwiperをリフレッシュ
    swiperThumbnail.update();

    // メインとサムネイルの同期を再設定
    swiper.params.thumbs.swiper = swiperThumbnail;
    swiper.update();
  };

  // 初期状態の同期
  syncSlides();

  // MutationObserverでAコードを監視
  const observerCallback = (mutationsList) => {
    let reorderDetected = false;

    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // スライドに変更があればフラグを立てる
        reorderDetected = true;
      }
    });

    if (reorderDetected) {
      console.log('refresh');
      syncSlides(); // Aコードの変更をBコードに反映
      swiper.slideTo(0); // 必要ならスライド位置をリセット
    }
  };

  // MutationObserverのオプション
  const observerOptions = {
    childList: true, // 子ノードの追加・削除を監視
    subtree: false,  // 子孫要素は監視しない
  };

  // MutationObserverの初期化と監視の開始
  const observer = new MutationObserver(observerCallback);
  observer.observe(swiperWrapper, observerOptions);

  // サムネイルクリック時にメインを同期させる (手動での同期処理)
  swiperWrapperThumbnail.addEventListener('click', (event) => {
    const clickedSlide = event.target.closest('.swiper-slide');
    if (clickedSlide) {
      const clickedIndex = Array.from(swiperWrapperThumbnail.children).indexOf(clickedSlide);
      swiper.slideToLoop(clickedIndex); // メインSwiperをサムネイルに同期
    }
  });
});



document.addEventListener('DOMContentLoaded', function () {
  // 監視対象の親要素を指定
  const targetNode = document.body;

  // MutationObserverのコールバック関数
  const observerCallback = (mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        const colorSwatches = document.querySelectorAll('.color-swatch');
        if (colorSwatches.length > 0) {
          //console.log('色バッジが見つかりました。');
          observer.disconnect(); // 監視を停止
          attachColorSwatchEvent(colorSwatches); // イベントを追加
        }
      }
    });
  };

  // MutationObserverのオプション
  const observerOptions = {
    childList: true,
    subtree: true,
  };

  // MutationObserverの初期化
  const observer = new MutationObserver(observerCallback);

  // 監視を開始
  observer.observe(targetNode, observerOptions);
});

function attachColorSwatchEvent(colorSwatches) {
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      const baseImageUrl = this.getAttribute('data-image'); // 画像URL
      const newImageUrl = baseImageUrl.replace('_medium', '');
      const productId = this.getAttribute('data-product-id'); // 商品ID
      const productImage = document.querySelector(`#main-image-${productId}`);

      if (productImage) {
        productImage.src = newImageUrl;
        productImage.srcset = '';
        document.querySelectorAll(`.color-swatch[data-product-id="${productId}"]`).forEach(swatch => {
          swatch.classList.remove('active');
        });
        this.classList.add('active');
        //console.log(`画像を変更しました: ${newImageUrl}`);
      }
    });
  });
}